import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitFilterManager = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) => filter.manager
)
